export const DietaryRestrictions = [
    {
        eventQuestionId: 0,
        eventId: 0,
        isMandatoryQuestion: true,
        eventQuestion: "Do you have any dietary restrictions? If yes, please elaborate.",
        eventQuestionTypeId: 2,
        isFeedbackQuestion: false,
        answers: [
            {
                "eventQuestionAnswerId": 0,
                "eventQuestionId": 0,
                "eventQuestionAnswer": "Halal",
                "isOther": false
            },
            {
                "eventQuestionAnswerId": 0,
                "eventQuestionId": 0,
                "eventQuestionAnswer": "Vegan",
                "isOther": false
            },
            {
                "eventQuestionAnswerId": 0,
                "eventQuestionId": 0,
                "eventQuestionAnswer": "Vegetarian",
                "isOther": false
            },
            {
                "eventQuestionAnswerId": 0,
                "eventQuestionId": 0,
                "eventQuestionAnswer": "Pescatarian",
                "isOther": false
            },
            {
                "eventQuestionAnswerId": 0,
                "eventQuestionId": 0,
                "eventQuestionAnswer": "Others (e.g. allergies)",
                "isOther": true
            },
            {
                "eventQuestionAnswerId": 0,
                "eventQuestionId": 0,
                "eventQuestionAnswer": "No",
                "isOther": false
            },
        ],
        isOther: false,
    },

]